import _ from 'lodash';

const breakpoints = ['sm', 'md', 'lg', 'xl', 'xxl'];

export const spacingsGenerator = (props) => {
    const spacingClasses = [
        'm', 'mt', 'mb', 'ms', 'me', 'mx', 'my',
        'p', 'pt', 'pb', 'ps', 'pe', 'px', 'py',
    ];

    const result = _.flatten(spacingClasses.map((name) => {
        return ['', ...breakpoints].map(b => {
            const val = [name, b].filter(Boolean).join('-');
            return {
                prop: _.camelCase(val),
                class: val
            }
        })
    }));

    return generator(result, props);
}

export const innerSpacingsGenerator = (props) => {
    const spacingClasses = ['s'];

    const result = _.flatten(spacingClasses.map((name) => {
        return ['', ...breakpoints].map(b => {
            const val = [name, b].filter(Boolean).join('-');
            return {
                prop: _.camelCase(val),
                class: val
            }
        })
    }));

    return generator(result, props);
}

export const textAlignGenerator = (props) => {
    const values = ['start', 'end', 'center'];

    const result = _.flatten(values.map((name) => {
        return ['', ...breakpoints].map(b => {
            const val = ['text', b].filter(Boolean).join('-');
            return {
                prop: 'textAlign' + _.capitalize(b),
                class: val
            }
        })
    }));

    return generator(result, props);
}

export const fontSizeGenerator = (props) => {
    const values = Array(11).fill(0).map((_, index) => index + 1);

    const result = _.flatten(values.map((name) => {
        return ['', ...breakpoints].map(b => {
            const val = ['font-size', b].filter(Boolean).join('-');
            return {
                prop: 'fontSize' + _.capitalize(b),
                class: val
            }
        })
    }));

    return generator(result, props);
}

export const fontWeightGenerator = (props) => {
    const values = Array(11).fill(0).map((_, index) => index + 1);

    const result = _.flatten(values.map((name) => {
        return ['', ...breakpoints].map(b => {
            const val = ['font-weight', b].filter(Boolean).join('-');
            return {
                prop: 'fontWeight' + _.capitalize(b),
                class: val
            }
        })
    }));

    return generator(result, props);
}


export const backgroundGenerator = (props) => {
    const result = ['', ...breakpoints].map(b => {
        const val = ['bg', b].filter(Boolean).join('-');
        return {
            prop: 'bgColor' + _.capitalize(b),
            class: val
        }
    });

    return generator(result, props);
};

export const textStylesGenerator = (props) => {
    const result = ['', ...breakpoints].map(b => {
        const val = ['text', b].filter(Boolean).join('-');
        return {
            prop: 'textColor' + _.capitalize(b),
            class: val
        }
    });

    return generator(result, props);
}

export const utilityClassesGenerator = (props) => {
    return [
        backgroundGenerator,
        textStylesGenerator,
        fontSizeGenerator,
        textAlignGenerator,
        spacingsGenerator,
        fontWeightGenerator,
    ].reduce((acc, fn) => {
        return {
            ...acc,
            ...fn(props)
        }
    }, {});
}

const generator = (classMap, componentProps) => {
    const propNames = classMap.reduce((acc, value) => {
        const key = value.prop || value;
        const className = value.class || value;

        if (componentProps[key] !== undefined) {
            acc[`${className}-${componentProps[key]}`] = true;
        }

        return acc;
    }, {});

    return propNames;
}

